export class NotificationsPreferences {
    workOrderId: number;
    enableReadNotification: boolean;
}
